{
  "actions": "Дії"
}
